import React from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import './styles.scss';
import AnnexusLogoSVGR from '../../assets/svgr/AnnexusLogoSVGR';
import NorthAmericanMenuSVGR from '../../assets/svgr/NorthAmericanMenuSVGR';

const Footer = () => (
  <footer className='footer-container'>
    <Container>
      <Grid
        container
        direction='row'
        justifyContent='flex-start'
        alignItems='center'
      >
        <Grid item mobile={12} pl={12} className='grid-footer'>
          <p>
            Life insurance policies have terms under which the policy may be continued in force or discontinued. Current cost of insurance rates and interest rates are not guaranteed. Therefore, the planned periodic premium may not be sufficient to carry the contract to maturity. The Index Accounts are subject to caps, participation and spread rates. In no case will the interest credited be less than 0 percent. Please refer to the customized illustration provided by your agent for additional detail. The policy’s death benefit is paid upon the death of the insured. The policy does not continue to accumulate cash value and excess interest after the insured’s death. For costs and complete details, call or write North American Company for Life and Health Insurance, One Sammons Plaza, Sioux Falls, SD 57193.
          </p>
          <p>
            <sup>1</sup>
            {' '}
            The PlanGap&reg; Benefit is known as the Income Gap Benefit in the policy. The Benefit can be elected if the Income Gap Benefit Index
            is reduced by more than 3%. Limited to the insured’s policy age being between age 62 and 85 and waiting period of 10 years for
            issue ages 0-59, and 5 years for issue ages 60+. The PlanGap&reg; Benefit is not a replacement for social security benefits but provides
            a benefit designed to mitigate a reduction. For purposes of this Endorsement, reduction means a reduction in social security benefits
            due to a change implemented by the Social Security Administration or other federal law or regulation. It does not include reductions
            in your social security benefits based upon your actions (including any elections under social security or changes to your social
            security elections) or change in circumstances. PlanGap&reg; is a registered trademark of PlanGap, LLC and is used pursuant to a license.
          </p>
          <p>
            <sup>2</sup>
            {' '}
            It is important to note that a reduction in benefits is only one possible solution. The Social Security administration could increase
            taxation, raise the full retirement age and implement a means-test that would reduce benefits for high earners, or any combination
            of these four possibilities.
          </p>
          <br />
          <p>
            Source: The 2026 Annual Report of the Board of Trustees of the Federal Old-Age and Survivors Insurance and Federal Disability
            Insurance Trust Funds.
          </p>
          <p>
            The results from the Lifetime Social Security Estimator are not a recommendation to buy, sell, hold or roll over any asset, adopt a
            financial strategy or use a particular account type. It does not take into account the specific investment objectives, tax and
            financial condition or particular needs of any specific person. Clients should work with their financial professional to discuss
            their specific situation.
          </p>
          <p>
            The Lifetime Social Security Estimator was created for educational use only. The calculations are based on the information you
            provided and have been generated by PlanGap&reg; and are believed to be reliable. North American makes no guarantee as to the accuracy
            of the calculations or the applicability to your individual circumstances and cannot be held liable for loss resulting from the
            use of information provided by this analysis.
          </p>
          <p>
            The general assumptions used in this tool may change over time and do not represent actual Social Security results, do not
            guarantee future results, and do not represent a recommendation from North American, Annexus, PlanGap&reg; or any of their affiliates.
            Please see the Social Security Administration’s website at
            {' '}
            <a href='https://www.ssa.gov/' target='_blank' rel='noreferrer'>www.ssa.gov</a>
            {' '}
            for more information, restrictions, and limitations regarding Social Security benefits.
          </p>
          <p>
            The term financial professional is not intended to imply engagement in an advisory business in which compensation is not
            related to sales. Financial professionals that are insurance licensed will be paid a commission on the sale of an insurance product.
          </p>
          <p>
            Neither North American Company for Life and Health Insurance&reg; nor any of its affiliates are affiliated with PlanGap&reg; or
            the Social Security Administration. North American&apos;s product(s) are not sponsored, endorsed, sold or promoted
            by the Social Security Administration, and they make no representation regarding the advisability of purchasing of the product(s).
          </p>
          <p>
            Annexus and their affiliated agencies are independently contracted with North American Company for Life and Health Insurance.
          </p>
          <p>
            Indexed universal life products are not an investment in the “market” or in the applicable index and are subject to all policy fees and charges normally associated with most
            universal life insurance.
          </p>
          <p>
            Secure Horizon IUL is issued on form P100/ICC22P100 (policy), E100/ICC22E100, E101/ICC22E101, E103/ICC22E103, E104/ICC22E104, E105/ICC22E105, E109/ICC22E109, E110/ICC22E110,
            E111/ICC22E111, E115/ICC24E115, E117, R100/ICC23R100, R101/ICC23R101, R102/ICC23R102, R103/ICC23R103, R106/ICC22R106, (riders/endorsements) or appropriate state variation
            by North American Company for Life and Health Insurance&reg;, West Des Moines, IA. Products, features, endorsements, riders or issue ages may not be available in all states.
            Limitations or restrictions may apply.
          </p>
          <p>
            Sammons Financial&reg; is the marketing name for Sammons&reg; Financial Group, Inc.’s member companies, including North American
            Company for Life and Health Insurance&reg;. Annuities and life insurance are issued by, and product guarantees are solely the
            responsibility of, North American Company for Life and Health Insurance.
          </p>
          <p className='left'>
            1822NW-22
          </p>
          <p className='right'>
            07/26
          </p>
        </Grid>
      </Grid>
      <Grid
        container
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        mb={{ xs: 6, sm: 4 }}
        mt={{ xs: 5, sm: 0 }}
      >
        <NorthAmericanMenuSVGR />
        <AnnexusLogoSVGR />
      </Grid>
    </Container>

  </footer>
);

export default Footer;
